/**
 * Form validation
 *
 * @since 1.0.0
 */
import 'script-loader!hyperform/dist/hyperform.js'

const FormValidation = () => {
  window.hyperform(window)
  const inputs = document.querySelectorAll('input,textarea,select')

  ;[...inputs].forEach(input => {
    if (input.required) {
      input.addEventListener('invalid', e => e.preventDefault())
    }
  })

  initRecaptcha()
}

function initRecaptcha () {
  if (typeof window.site.vars.recaptcha_key === 'undefined' ||
    !window.site.vars.recaptcha_key) {
    return
  }

  window.initRecaptcha = onRecaptchaLoad

  let script = document.createElement('script')
  script.setAttribute('src',
    'https://www.google.com/recaptcha/api.js?onload=initRecaptcha&render=explicit')
  script.setAttribute('type', 'text/javascript')

  document.body.appendChild(script)
}

function onRecaptchaLoad () {
  const forms = document.querySelectorAll('form.js-form');

  [...forms].forEach((form) => {
    let recaptchaContainer = document.createElement('div')
    recaptchaContainer.classList.add('g-recaptcha')

    form.recaptcha = {
      id: grecaptcha.render(recaptchaContainer, {
        sitekey: window.site.vars.recaptcha_key,
        size: 'invisible',
        callback: token => onRecaptchaCallback(token, form),
      }),
      validated: false,
    }

    form.appendChild(recaptchaContainer)
    form.addEventListener('validate', onSubmit)
  })
}

function onSubmit (e) {
  if (typeof e.target.recaptcha.id === 'undefined' ||
    e.target.recaptcha.validated) {
    return
  }

  e.preventDefault()
  grecaptcha.execute(e.target.recaptcha.id)
}

function onRecaptchaCallback (token, form) {
  form.recaptcha.validated = true

  const buttons = form.querySelectorAll('.js-loading-button');

  [...buttons].forEach((button) => {
    button.click()
  })
}

export default FormValidation

// WEBPACK FOOTER //
// ./src/js/modules/FormValidation.js